import { render } from "./AddFromCatalogPopover.vue?vue&type=template&id=70f034bb&scoped=true"
import script from "./AddFromCatalogPopover.vue?vue&type=script&lang=js"
export * from "./AddFromCatalogPopover.vue?vue&type=script&lang=js"

import "./AddFromCatalogPopover.vue?vue&type=style&index=0&id=70f034bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f034bb"]])

export default __exports__